import React, { memo, useEffect } from 'react';
import { Dialog, DialogTitle } from '@mui/material';
import { t } from 'i18next';
import { useFormik } from 'formik';
import * as yup from 'yup';
import useFormSubmit from 'hooks/useFormSubmit';
import { useAppInfo } from 'context';
import FormActionButtons from 'components/ui/form/FormActionButtons';
import FormDateField from 'components/ui/form/FormDateField';
import FormTextField from 'components/ui/form/FormTextField';
import moment from 'moment';

const validationSchema = yup.object({
  date: yup
    .date()
    .typeError('lead.addEditModal.validation.dateValid')
    .default(new Date())
    .required('lead.addEditModal.validation.date'),
  title: yup.string().required('majburiy'),
});

export default memo(function TaskTimeModal({
  data,
  setData,
  open,
  setOpen,
  refetchFn = () => {},
}) {
  const onClose = () => setOpen(null);
  const [{ refetchTaskCount }] = useAppInfo();
  const { submit, isSubmitting } = useFormSubmit();
  const formik = useFormik({
    initialValues: {
      date: '',
      title: '',
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      if (data?.id) {
        const body = {
          title: values?.title,
          date: values?.date
            ? moment(values?.date).format('YYYY-MM-DD HH:mm')
            : null,
          ids: [data?.id],
        };
        submit(
          { type: 'post ', contentType: 'simple' },
          body,
          '/crm/task/time',
          'date task',
          null,
          true,
          () => {
            refetchFn();
            refetchTaskCount?.();
            setData?.({});
          }
        );
      }
    },
  });

  useEffect(() => {
    if (data?.id) {
      formik.setValues({ date: data?.date, title: data?.title });
    }
  }, [data]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth='lg'
      PaperProps={{ className: '!base-border !shadow-none !overflow-hidden' }}
    >
      <DialogTitle
        id='alert-dialog-title'
        className='!bg-[#CDCDCDC7] !text-center !border-b !border-b-[#E6E6E6]'
      >
        <span className='pr-5 font-semibold text-[21px] text-[#374957]'>
          {t('tasks.time.title')}
        </span>
      </DialogTitle>
      <div className='py-4 px-8 min-w-[600px]'>
        <form onSubmit={formik.handleSubmit}>
          <div className='flex justify-center flex-col gap-4'>
            <div>
              <FormDateField
                delay={0}
                duration={0.5}
                label={t('common.fields.date')}
                fieldName={'date'}
                formik={formik}
              />
            </div>
            <div>
              <FormTextField
                delay={0}
                duration={0.5}
                label={t('common.fields.comment')}
                fieldName={'title'}
                formik={formik}
                multiline
                rows='4'
              />
            </div>
            <div className='flex justify-end'>
              <FormActionButtons
                delay={0}
                isSubmitting={isSubmitting}
                formType='dialog'
                setOpen={setOpen}
                reset={formik.resetForm}
              />
            </div>
          </div>
        </form>
      </div>
    </Dialog>
  );
});
